<template>
    <div class="kanban-container" ref="kanban">
        <div class="production-kanban-header">【{{ companyName }}】CNC加工实时看板</div>

        <div style="overflow: auto; height: 79%">
            <table class="kanban-table" style="width: 960px">
                <tr>
                    <!-- <td style="width: 15px; max-width: 15px">设备编号</td> -->
                    <td style="width: 20px; max-width: 20px">设备名称</td>

                    <td style="width: 20px; max-width: 20px">运行时间</td>
                    <td style="width: 20px; max-width: 20px">暂停时间</td>
                    <td style="width: 20px; max-width: 20px">故障时间</td>

                    <td style="width: 15px; max-width: 15px">设备状态</td>

                    <td style="width: 20px; max-width: 20px">运行时长(m)</td>
                    <td style="width: 20px; max-width: 20px">暂停时长(m)</td>
                    <td style="width: 6px; max-width: 6px">暂停次数</td>
                    <td style="width: 20px; max-width: 20px">故障时长(m)</td>
                </tr>

                <tr v-for="(item, index) in equipmentList" :key="index">
                    <!-- <td>{{ item.equipmentCode }}</td> -->
                    <td>{{ item.equipmentName }}</td>

                    <td>{{ item.workTime }}</td>
                    <td>{{ item.pauseTime }}</td>
                    <td>{{ item.badTime }}</td>

                    <!-- <td>{{ item.status }}</td> -->
                    <td
                        :class="item.status == '暂停' ? 'kanban-td-o' : item.status == '加工' ? 'kanban-td-g' : 'kanban-td-r'">
                        {{ item.status }}</td>

                    <td>{{ item.workDuration }}</td>
                    <td>{{ item.pauseDuration }}</td>
                    <td>{{ item.pauseCount }}</td>
                    <td>{{ item.badDuration }}</td>
                </tr>
            </table>

            <div style="height: 10px"></div>
        </div>

        <div style="height: 10px"></div>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount"
                layout="total, sizes,prev, pager, next" :total="total" @current-change="pageClick"
                :page-sizes="[10, 15, 20, 25]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

        <div style="height: 10px"></div>

        <div style="position: absolute; right: 30px; bottom: 5px">
            <i class="el-icon-full-screen" @click="fullScreen" style="color: orange"></i>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            companyName: "中国制造",

            equipmentList: [],

            index: 0,

            pageIndex: 0,
            pageNum: 10,
            total: 0,
            pageCount: 0,

            timer: ''
        }
    },
    methods: {
        getAll() {
            this.$axios({
                method: "post",
                url: "/shiro/equipment/getAll",
                data: {
                    id: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                if (data.status === 400) {

                    clearInterval(this.timer)

                    this.$router.push({ path: "/Login" })
                }

                var eList = data.data
                for (let i in eList) {
                    if (eList[i].status == 1) {
                        eList[i].status = '暂停'
                    } else if (eList[i].status == 2) {
                        eList[i].status = '加工'
                    } else {
                        eList[i].status = '故障'
                    }

                    eList[i].pauseTime = eList[i].pauseTime == null ? '' : this.$moment(eList[i].pauseTime).format("MM-DD HH:mm")
                    eList[i].workTime = eList[i].workTime == null ? '' : this.$moment(eList[i].workTime).format("MM-DD HH:mm")
                    eList[i].badTime = eList[i].badTime == null ? '' : this.$moment(eList[i].badTime).format("MM-DD HH:mm")
                }
                this.equipmentList = eList

            })
        },
        fullScreen() {

            let element = this.$refs.kanban

            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen

        },
        pageClick(currentPage) {
            this.purchaseKanbanList = []

            this.pageIndex = (currentPage - 1) * this.pageNum
            this.getAll()
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.pageNum = val

            this.getAll()
        },
    },
    mounted() {
        this.getAll()

        this.$axios({
            method: "post",
            url: "/shiro/company/get",
            data: {
                id: this.companyId,
            },
            headers: {
                token: this.token,
            },
        }).then((result) => {

            this.companyName = result.data.data.companyName
        })

        this.timer = setInterval(() => {
            this.getAll()
        }, 55000)

    },
    updated() {
        
    }
};
</script>

<style>
.kanban-container {
    width: 100%;
    height: 800px;
    background-color: #06207d;
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    position: relative;
}

.production-kanban-header {
    font-size: 25px;
    font-weight: bolder;
    color: white;
    line-height: 100px;
}

.kanban-table {
    width: 556px;
    table-layout: fixed;
    border: 1px solid white;
    font-size: 15px;
    font-weight: bold;
    color: white;
    border-collapse: collapse;
}

.kanban-tr-odd {
    font-size: 11px;
    color: black;
    background-color: white;
}

.kanban-tr {
    font-size: 11px;
    color: black;
    background-color: greenyellow;
}

.kanban-table td {
    border: 1px solid white;
    padding: 5px 0;
}

.kanban-td-o {
    background-color: orange;
}

.kanban-td-g {
    background-color: green;
}

.kanban-td-r {
    background-color: red;
}

.kanban-tr-odd td,
.kanban-tr td {
    border: 1px solid black;
}

div::-webkit-scrollbar {
    background: #6f5499;
    border-radius: 10px;
    width: 10px;
    height: 10px;
}

div::-webkit-scrollbar-thumb {
    background: orange;
    border-radius: 10px;
}

.el-pagination__total {
    color: pink;
}
</style>